export default {
    titulo: "Proveedores",
    nuevo: "Nuevo proveedor",
    eliminar: "Eliminar proveedor",
    pregEliminar: "¿Confirmas que deseas eliminar el proveedor?",
    editar: "Editar proveedor",
    observaciones: "Observaciones"
}